export function kanaToHira(str: string) {
  // 全角→半角 変換も行う
  return str
    .replace(/[\u30a1-\u30f6]/g, function(match) {
      const chr = match.charCodeAt(0) - 0x60
      return String.fromCharCode(chr)
    })
    .replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xfee0)
    })
}

export const autoCompleteFilter = (
  _item: any,
  _queryText: string,
  _itemText: string,
): boolean => {
  return true
  // const itemText = kanaToHira(_itemText.toLocaleLowerCase())
  // const queryTexts = _queryText
  //   .split(/\s/)
  //   .map(q => kanaToHira(q.toLocaleLowerCase()))
  // return queryTexts.every(queryText => {
  //   return itemText.indexOf(queryText) > -1
  // })
}
